var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError5003Background(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 577,
    viewBox: "0 0 1920 577",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.525 126.965H171.416V233.801C185.438 222.446 205.068 213.156 230.307 205.931C255.546 198.705 282.889 195.092 312.335 195.092C364.916 195.092 408.384 203.866 442.737 221.414C477.791 238.962 503.381 261.671 519.506 289.542C535.631 317.412 543.694 347.605 543.694 380.12C543.694 440.506 520.558 488.505 474.286 524.117C428.014 559.213 362.813 576.76 278.682 576.76C222.595 576.76 173.87 569.793 132.506 555.858C91.1414 541.407 59.2419 521.536 36.8071 496.246C14.3723 470.957 2.10326 441.796 0 408.764H175.622C179.829 424.764 189.995 438.183 206.12 449.022C222.245 459.344 244.329 464.505 272.373 464.505C305.324 464.505 329.862 456.763 345.987 441.28C362.112 425.796 370.174 405.152 370.174 379.346C370.174 354.056 361.761 334.702 344.935 321.283C328.109 307.864 303.571 301.154 271.321 301.154C247.484 301.154 227.854 305.541 212.43 314.315C197.006 322.573 186.84 333.67 181.932 347.605H8.41305V10.8385H499.525V126.965Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.958 286.445C642.958 197.673 666.094 127.739 712.365 76.6434C759.338 25.5478 834.705 0 938.466 0C1042.23 0 1117.24 25.5478 1163.52 76.6434C1210.49 127.739 1233.97 197.673 1233.97 286.445C1233.97 376.249 1210.49 446.699 1163.52 497.795C1117.24 548.89 1042.23 574.438 938.466 574.438C834.705 574.438 759.338 548.89 712.365 497.795C666.094 446.699 642.958 376.249 642.958 286.445ZM1057.3 286.445C1057.3 234.317 1049.59 194.318 1034.16 166.448C1018.74 138.061 986.841 123.868 938.466 123.868C890.091 123.868 858.192 138.061 842.768 166.448C827.344 194.318 819.632 234.317 819.632 286.445C819.632 321.541 822.436 350.701 828.045 373.927C833.654 396.636 844.871 415.216 861.697 429.667C879.224 443.602 904.814 450.57 938.466 450.57C972.118 450.57 997.357 443.602 1014.18 429.667C1031.71 415.216 1043.28 396.636 1048.89 373.927C1054.5 350.701 1057.3 321.541 1057.3 286.445Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.98 286.445C1328.98 197.673 1352.12 127.739 1398.39 76.6434C1445.36 25.5478 1520.73 0 1624.49 0C1728.25 0 1803.27 25.5478 1849.54 76.6434C1896.51 127.739 1920 197.673 1920 286.445C1920 376.249 1896.51 446.699 1849.54 497.795C1803.27 548.89 1728.25 574.438 1624.49 574.438C1520.73 574.438 1445.36 548.89 1398.39 497.795C1352.12 446.699 1328.98 376.249 1328.98 286.445ZM1743.33 286.445C1743.33 234.317 1735.61 194.318 1720.19 166.448C1704.77 138.061 1672.87 123.868 1624.49 123.868C1576.12 123.868 1544.22 138.061 1528.79 166.448C1513.37 194.318 1505.66 234.317 1505.66 286.445C1505.66 321.541 1508.46 350.701 1514.07 373.927C1519.68 396.636 1530.9 415.216 1547.72 429.667C1565.25 443.602 1590.84 450.57 1624.49 450.57C1658.14 450.57 1683.38 443.602 1700.21 429.667C1717.74 415.216 1729.3 396.636 1734.91 373.927C1740.52 350.701 1743.33 321.541 1743.33 286.445Z",
    fill: "url(#paint2_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 939.674,
    y1: -38.2393,
    x2: 939.674,
    y2: 650.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 939.674,
    y1: -38.2393,
    x2: 939.674,
    y2: 650.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 939.674,
    y1: -38.2393,
    x2: 939.674,
    y2: 650.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError5003Background);
export default __webpack_public_path__ + "static/media/error_500_3_background.d442d95dca3d6942c195e3481bfe97b8.svg";
export { ForwardRef as ReactComponent };